import React, { useEffect } from 'react';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import {
  userAccountAtom,
  changeUserAtom,
} from '../../models/atoms/account_atoms';
import {
  companyDeviceSettingsAtom,
  companyWeathermodeSettingsAtom,
  changeCompanyDeviceAtom,
  changeWeathermodeAtom,
  companyLowPowerSettingsAtom,
  changeLowPowerAtom,
  companyROCSettingsAtom,
  changeROCAtom,
  originalCompanyDeviceAtom,
} from '../../models/atoms/company_atoms';
import { getRecoil, setRecoil } from 'recoil-nexus';
import { DeviceSettingsComponent } from '../components/settings/DeviceSettings';
import { LowPowerSettingsComponent } from '../components/settings/LowPowerSettings';
import { WeatherModeSettingsComponent } from '../components/settings/WeatherModeSettings';
import { LabelSettingsComponent } from '../components/settings/LabelSettings';
import { AccountSettingsComponent } from '../components/settings/AccountSettings';
import { AlertSettingsComponent } from '../components/settings/AlertSettings';
import { BatteryLifeSettingsComponent } from '../components/settings/BatteryLifeSettings';
import { APIDocsSettingsComponent } from '../components/settings/APIDocsSettings';
import {
  SettingsHeader,
  SettingsNav,
} from '../components/settings/SettingsNav';
import { Stack } from '@mui/material';
import { Menu } from '@mui/icons-material';
import { company_controller } from '../../controllers/company_controller';
import { useIsMobile } from '../../hooks/useIsMobile';
import { MHMIconButton } from '../components/MHM/MHMIconButton';
import { ManualsSettingsComponent } from '../components/settings/ManualsSettings';
/* eslint-disable no-useless-escape */

export const SettingsPage = memo(function SettingsPage(
  _: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <>
      <SettingsStateManager></SettingsStateManager>
      <SettingsPageUI></SettingsPageUI>
    </>
  );
});

const SettingsStateManager = memo(function SettingsStateManager(
  _: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  const user = useRecoilValue(userAccountAtom);
  const company = useRecoilValue(companyDeviceSettingsAtom);
  const company_weathermode = useRecoilValue(companyWeathermodeSettingsAtom);
  const company_low_power = useRecoilValue(companyLowPowerSettingsAtom);
  const company_roc = useRecoilValue(companyROCSettingsAtom);

  useEffect(() => {
    company_controller.get_device_settings();
    company_controller.get_weathermode_settings();
    company_controller.get_roc_settings();
    company_controller.get_low_power_settings();
  }, []);

  console.log('change');
  if (user !== null) {
    setRecoil(changeUserAtom, {
      ...user,
      change_alert_mediums: false,
      change_alert_types: false,
      change_email_phone: false,
      change_first_name: false,
      change_last_name: false,
    });
    console.log(getRecoil(changeUserAtom));
  }
  if (company !== null) {
    setRecoil(originalCompanyDeviceAtom, company);
    setRecoil(changeCompanyDeviceAtom, {
      ...company,
      change_time: false,
    });
  }
  if (company_weathermode !== null) {
    setRecoil(changeWeathermodeAtom, {
      ...company_weathermode,
      change_weathermode: false,
    });
  }
  if (company_roc !== null) {
    setRecoil(changeROCAtom, {
      ...company_roc,
      change_roc: false,
    });
  }
  if (company_low_power !== null) {
    setRecoil(changeLowPowerAtom, {
      ...company_low_power,
      change_low_power: false,
    });
  }
  return <></>;
});

const SettingsPageUI = memo(function SettingsPageUI(
  _: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  const times = useRecoilValue(changeCompanyDeviceAtom);
  const [open, setOpen] = React.useState(true);
  const isMobile = useIsMobile();

  if (!times) {
    return <></>;
  }

  return (
    <>
      <Stack direction="row" height="100%">
        {/** menu */}
        <SettingsNav open={open} setOpen={setOpen} />

        <Stack>
          {isMobile && (
            <SettingsHeader>
              <MHMIconButton
                aria-label="settings-menu"
                color="default"
                sx={{
                  p: 0,
                }}
                onClick={() => setOpen(true)}
              >
                <Menu fontSize="large" />
              </MHMIconButton>
            </SettingsHeader>
          )}
          <Stack gap={2} px={isMobile ? 0 : 2} sx={{ overflowY: 'auto' }}>
            <DeviceSettingsComponent />
            <LowPowerSettingsComponent />
            <APIDocsSettingsComponent />
            <ManualsSettingsComponent />
            <BatteryLifeSettingsComponent />
            <WeatherModeSettingsComponent />
            <LabelSettingsComponent />
            <AccountSettingsComponent />
            <AlertSettingsComponent />
          </Stack>
        </Stack>
      </Stack>
    </>
  );
});
